export const initialState = {}

export const getData = (state,delta) => state.data || null


// WEBPACK FOOTER //
// ./src/interface/store/departments/dialog/selectors.js